<template>
  <div align="center" style="overflow-x: scroll">
    <!-- <pre>{{ items }}</pre> -->
    <h3>AS Plant</h3>
    <br />
    <!-- <vs-button
      color="primary"
      @click="tableToExcel('testTable', 'W3C Example Table')"
      type="filled"
      >Primary</vs-button
    > -->

    <table id="testTable1" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.as != undefined">
      <tbody>
        <tr>
          <td align="center" colspan="10">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of AS Wastewater Treatment Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr>
          <td align="center" rowspan="2">Plant</td>
          <td align="center" colspan="4">Quantity in Used</td>
          <td align="center" colspan="3">Cost in Used</td>
          <td align="center" colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr>
          <td align="center" colspan="4">Quantity</td>
          <td align="center" colspan="3">Cost</td>
        </tr>
        <tr>
          <td align="center">AS</td>
          <td align="center" colspan="2">Water</td>
          <td align="center">Electricity</td>
          <td align="center">sludge</td>
          <td align="center">Cost of Electricity</td>
          <td align="center">Cost of sludge</td>
          <td>Total cost</td>
          <td align="center">Cost of Chem./motorcycle</td>
          <td align="center">ค่าบำบัดน้ำ/m3</td>
        </tr>
        <tr>
          <td align="center">หน่วย</td>
          <td align="center">Toilet (m3) (ENV-AS-11)</td>
          <td align="center">Treat in AS (m3)</td>
          <td align="center">(Unit)</td>
          <td align="center">(Big bags)</td>
          <td align="center">Bath.</td>
          <td align="center">Bath.</td>
          <td align="center">Bath.</td>
          <td align="center">Bath./Unit</td>
          <td align="center">Bath/m3</td>
        </tr>
        <tr v-for="(i, index) in items.as.powerData" :key="i" align="center">
          <td>{{ i == undefined ? "" : i.time }}</td>
          <td>
            {{
              items.as.waterData[index] == undefined
              ? "0.00"
              : items.as.waterData[index].water1
            }}
          </td>
          <td>
            {{
              items.as.waterData[index] == undefined
              ? "0.00"
              : items.as.waterData[index].water2
            }}
          </td>
          <td>{{ i == undefined ? "" : i.power }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td align="center">TOTAL</td>
          <td align="center">{{ items.as.totalData.waterdata.total1 }}</td>
          <td align="center">{{ items.as.totalData.waterdata.total2 }}</td>
          <td align="center">{{ items.as.totalData.powerdata.total }}</td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
        </tr>
        <tr>
          <td>AVERAGE</td>
          <td align="center">{{ items.as.totalData.waterdata.avg1 }}</td>
          <td align="center">{{ items.as.totalData.waterdata.avg2 }}</td>
          <td align="center">{{ items.as.totalData.powerdata.avg }}</td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
        </tr>
      </tbody>
    </table>
    <br />

    <h3>RO Plant</h3>
    <br />
    <table id="testTable2" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.ro != undefined">
      <tbody>
        <tr align="center">
          <td colspan="26">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of RO Recycle Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr align="center">
          <td rowspan="2">Plant</td>
          <td colspan="15">Quantity in Used</td>
          <td colspan="8">Cost in Used</td>
          <td colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr align="center">
          <td colspan="3">RO Water</td>
          <td colspan="12">Quantity</td>
          <td colspan="8">Cost</td>
        </tr>
        <tr align="center">
          <td>RO Recycle</td>
          <td>RO Water</td>
          <td>Brine Water</td>
          <td>Electricity</td>
          <td colspan="2">Antiscale (N-900)</td>
          <td colspan="2">Biocide (IK-110)</td>
          <td colspan="2">SBS (Na2S2O5)</td>
          <td colspan="2">NaOCl</td>
          <td colspan="2">NaOH 0.1%</td>
          <td colspan="2">Citric Acid 2%</td>
          <td>Cost of Electricity</td>
          <td>Cost of Antiscale</td>
          <td>Cost of Biocide</td>
          <td>Cost of SBS</td>
          <td>Cost of NaOCl</td>
          <td>Cost of NaOH</td>
          <td>Cost of Citric Acid</td>
          <td>Total Cost of Chem.</td>
          <td>Cost of Chem./motorcycle</td>
          <td>ค่าบำบัดน้ำ/m3</td>
        </tr>
        <tr align="center">
          <td>หน่วย</td>
          <td>(m3)</td>
          <td>(m3)</td>
          <td>(Unit)</td>
          <td>L</td>
          <td>kg.</td>
          <td>L</td>
          <td>kg.</td>
          <td>L</td>
          <td>kg.</td>
          <td>L</td>
          <td>kg.</td>
          <td>NaOH 0.1% (L.)</td>
          <td>NaOH 50% (kg.)</td>
          <td>Citric Acid 2% (L.)</td>
          <td>Citric Acid 100% (kg.)</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath./Unit</td>
          <td>Bath/m3</td>
        </tr>

        <tr v-for="(i, index) in items.ro.powerData" :key="i" align="center">
          <td>{{ i == undefined ? "" : i.time }}</td>
          <td>
            {{
              items.ro.waterData[index] == undefined
              ? "0.00"
              : items.ro.waterData[index].water2
            }}
          </td>
          <td>
            {{
              items.ro.waterData[index] == undefined
              ? "0.00"
              : parseFloat(items.ro.waterData[index].water2 * 0.92).toFixed(2)
            }}
          </td>
          <td>{{ i == undefined ? "" : i.power }}</td>
          <td>
            {{
              items.ro.RolevelData[index] == undefined
              ? "0.00"
              : items.ro.RolevelData[index].memtreat300
            }}
          </td>
          <td></td>
          <td>
            {{
              items.ro.RolevelData[index] == undefined
              ? "0.00"
              : items.ro.RolevelData[index].memtreat_bio
            }}
          </td>
          <td></td>
          <td>
            {{
              items.ro.RolevelData[index] == undefined
              ? "0.00"
              : items.ro.RolevelData[index].sodium_metabisulfit
            }}
          </td>
          <td></td>
          <td>
            {{
              items.ro.RolevelData[index] == undefined
              ? "0.00"
              : items.ro.RolevelData[index].naocl
            }}
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>TOTAL</td>
          <td>{{ items.ro.totalData.waterdata.total1 }}</td>
          <td>{{ parseFloat(items.ro.totalData.waterdata.total1 * 0.92).toFixed(2) }}</td>
          <td>{{ items.ro.totalData.powerdata.total }}</td>
          <td>{{ items.ro.totalData.leveldata.total1 }}</td>
          <td></td>
          <td>{{ items.ro.totalData.leveldata.total2 }}</td>
          <td></td>
          <td>{{ items.ro.totalData.leveldata.total3 }}</td>
          <td></td>
          <td>{{ items.ro.totalData.leveldata.total4 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>AVERAGE</td>
          <td>{{ items.ro.totalData.waterdata.avg1 }}</td>
          <td>{{ parseFloat(items.ro.totalData.waterdata.avg1 * 0.92).toFixed(2) }}</td>
          <td>{{ items.ro.totalData.powerdata.avg }}</td>
          <td>{{ items.ro.totalData.leveldata.avg1 }}</td>
          <td></td>
          <td>{{ items.ro.totalData.leveldata.avg2 }}</td>
          <td></td>
          <td>{{ items.ro.totalData.leveldata.avg3 }}</td>
          <td></td>
          <td>{{ items.ro.totalData.leveldata.avg4 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <br />
    <h3>Recycle Plant</h3>
    <br />
    <table id="testTable3" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.recycle != undefined">
      <tbody>
        <tr align="center">
          <td colspan="13">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of Recycle Water Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr align="center">
          <td rowspan="2">Plant</td>
          <td colspan="7">Quantity in Used</td>
          <td colspan="3">Cost in Used</td>
          <td colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr align="center">
          <td colspan="3">Quantity of Water</td>
          <td colspan="2">Quantity of Electricity</td>
          <td colspan="2">Quantity of Chemical</td>
          <td colspan="3">Cost of Chemical</td>
        </tr>
        <tr align="center">
          <td>RECYCLE</td>
          <td>Recycle water</td>
          <td>Supply Garden</td>
          <td>Supply Toilet</td>
          <td colspan="2">Electricity</td>
          <td colspan="2">NaOCl</td>
          <td>Cost of Electricity</td>
          <td>Cost of NaOCl</td>
          <td>Total cost</td>
          <td>Cost of Chem./motorcycle</td>
          <td>ค่าบำบัดน้ำ/m3</td>
        </tr>
        <tr align="center">
          <td>หน่วย</td>
          <td>(m3)</td>
          <td>(m3)</td>
          <td>(m3)</td>
          <td>(Unit)</td>
          <td>Unit x CT Factory</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath./Unit</td>
          <td>Bath/m3</td>
        </tr>
        <tr v-for="(i, index) in items.recycle.powerData" :key="i" align="center">
          <td>{{ i == undefined ? "" : i.time }}</td>
          <td>
            {{
              items.recycle.waterData[index] == undefined
              ? "0.00"
              : items.recycle.waterData[index].water3
            }}
          </td>
          <td>
            {{
              items.recycle.waterData[index] == undefined
              ? "0.00"
              : items.recycle.waterData[index].water2
            }}
          </td>
          <td>
            {{
              items.recycle.waterData[index] == undefined
              ? "0.00"
              : items.recycle.waterData[index].water1
            }}
          </td>
          <td>{{ i == undefined ? "0.00" : i.power }}</td>
          <td></td>
          <td>
            {{
              items.recycle.naoclData[index] == undefined
              ? "0.00"
              : items.recycle.naoclData[index].naocl
            }}
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>TOTAL</td>
          <td>{{ items.recycle.totalData.waterdata.total3 }}</td>
          <td>{{ items.recycle.totalData.waterdata.total2 }}</td>
          <td>{{ items.recycle.totalData.waterdata.total1 }}</td>
          <td>{{ items.recycle.totalData.powerdata.total }}</td>
          <td></td>
          <td>{{ items.recycle.totalData.naocldata.total }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>AVERAGE</td>
          <td>{{ items.recycle.totalData.waterdata.avg3 }}</td>
          <td>{{ items.recycle.totalData.waterdata.avg2 }}</td>
          <td>{{ items.recycle.totalData.waterdata.avg1 }}</td>
          <td>{{ items.recycle.totalData.powerdata.avg }}</td>
          <td></td>
          <td>{{ items.recycle.totalData.naocldata.avg }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <br />
    <h3>DAF Plant</h3>
    <br />
    <table id="testTable4" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.daf != undefined">
      <tbody>
        <tr align="center">
          <td colspan="15">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of DAF Wastewater Treatment Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr align="center">
          <td rowspan="2">Plant</td>
          <td colspan="6">Quantity in Used</td>
          <td colspan="6">Cost in Used</td>
          <td colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr align="center">
          <td></td>
          <td></td>
          <td colspan="4">Quantity of Chemical</td>
          <td colspan="6">Cost of Chemical</td>
        </tr>
        <tr align="center">
          <td>DAF</td>
          <td>Water</td>
          <td>Electricity</td>
          <td>N73046</td>
          <td>N7735</td>
          <td>NaOH</td>
          <td>Polymer-9916 (g)</td>
          <td>Cost of Electricity</td>
          <td>Cost of N73046</td>
          <td>Cost of 7735</td>
          <td>Cost of NaOH</td>
          <td>Cost of Polymer-9916</td>
          <td>Cost of Chemicals</td>
          <td>Cost of Chem./motorcycle</td>
          <td>ค่าบำบัดน้ำ/m3</td>
        </tr>
        <tr align="center">
          <td>หน่วย</td>
          <td>(m3)</td>
          <td>(Unit)</td>
          <td>(L)</td>
          <td>(L)</td>
          <td>(L)</td>
          <td>(L)</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath./Unit</td>
          <td>Bath/m3</td>
        </tr>
        <tr v-for="(i, index) in items.daf.powerData" :key="i" align="center">
          <td>{{ i == undefined ? "" : i.time }}</td>
          <td>
            {{
              items.daf.waterData[index] == undefined
              ? "0.00"
              : items.daf.waterData[index].water
            }}
          </td>
          <td>{{ i == undefined ? "0.00" : i.power }}</td>
          <td>
            {{
              items.daf.DAFlevelData[index] == undefined
              ? "0.00"
              : items.daf.DAFlevelData[index].n73046
            }}
          </td>
          <td>
            {{
              items.daf.DAFlevelData[index] == undefined
              ? "0.00"
              : items.daf.DAFlevelData[index].n7735
            }}
          </td>
          <td>
            {{
              items.daf.DAFlevelData[index] == undefined
              ? "0.00"
              : items.daf.DAFlevelData[index].naoh
            }}
          </td>
          <td>
            {{
              items.daf.DAFlevelData[index] == undefined
              ? "0.00"
              : items.daf.DAFlevelData[index].n9916
            }}
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>TOTAL</td>
          <td>{{ items.daf.totalData.waterdata.total }}</td>
          <td>{{ items.daf.totalData.powerdata.total }}</td>
          <td>{{ items.daf.totalData.leveldata.total1 }}</td>
          <td>{{ items.daf.totalData.leveldata.total2 }}</td>
          <td>{{ items.daf.totalData.leveldata.total4 }}</td>
          <td>{{ items.daf.totalData.leveldata.total3 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>AVERAGE</td>
          <td>{{ items.daf.totalData.waterdata.avg }}</td>
          <td>{{ items.daf.totalData.powerdata.avg }}</td>
          <td>{{ items.daf.totalData.leveldata.avg1 }}</td>
          <td>{{ items.daf.totalData.leveldata.avg2 }}</td>
          <td>{{ items.daf.totalData.leveldata.avg4 }}</td>
          <td>{{ items.daf.totalData.leveldata.avg3 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <br />
    <h3>Center Plant</h3>
    <br />
    <table id="testTable5" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.center != undefined">
      <tbody>
        <tr align="center">
          <td colspan="24">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of Center Wastewater Treatment Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr align="center">
          <td rowspan="2">Plant</td>
          <td colspan="13">Quantity in Used</td>
          <td colspan="8">Cost in Used</td>
          <td colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr align="center">
          <td></td>
          <td></td>
          <td colspan="10">Quantity of Chemical</td>
          <td></td>
          <td></td>
          <td colspan="6">Cost of Chemical</td>
          <td></td>
        </tr>
        <tr align="center">
          <td>CENTER</td>
          <td>Water</td>
          <td>Electricity</td>
          <td colspan="2">HCl (กรดเกลือ)</td>
          <td colspan="2">NaOH (โซดาไฟ)</td>
          <td colspan="2">FeCl3 (เฟอริค)</td>
          <td colspan="2">H<sub>2</sub>SO<sub>4</sub> (กรดซัลฟูริค)</td>
          <td colspan="2">Polymer</td>
          <td>sludge</td>
          <td>Cost of Electricity</td>
          <td>Cost of HCl</td>
          <td>Cost of NaOH</td>
          <td>Cost of FeCl3</td>
          <td>Cost of H<sub>2</sub>SO<sub>4</sub></td>
          <td>Cost of Polymer</td>
          <td>Total Cost of Chem.</td>
          <td>Cost of Sludge</td>
          <td>Cost of Chem./motorcycle</td>
          <td>ค่าบำบัดน้ำ/m3</td>
        </tr>
        <tr align="center">
          <td>หน่วย</td>
          <td>(m3)</td>
          <td>(Unit)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(g.)</td>
          <td>(Big bags)</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td></td>
          <td></td>
          <td>Bath./Unit</td>
          <td>Bath./Unit</td>
        </tr>
        <tr v-for="(i, index) in items.center.CenterlevelData" :key="i" align="center">
          <td>{{ i == undefined ? "" : i.time }}</td>
          <td>
            {{
              items.center.waterData.find(value => value.time === i.time)
              ? items.center.waterData.find(value => value.time === i.time).water
              : "0.00"
            }}
          </td>
          <td>
            {{
              items.center.powerData.find(value => value.time === i.time)
              ? items.center.powerData.find(value => value.time === i.time).power
              : "0.00"
            }}
          </td>
          <td></td>
          <td></td>
          <td>
            {{
              items.center.CenterlevelData[index] == undefined
              ? "0.00"
              : items.center.CenterlevelData[index].naoh
            }}
          </td>
          <td></td>
          <td>
            {{
              items.center.CenterlevelData[index] == undefined
              ? "0.00"
              : items.center.CenterlevelData[index].fecl3
            }}
          </td>
          <td></td>
          <td>
            {{
              items.center.CenterlevelData[index] == undefined
              ? "0.00"
              : items.center.CenterlevelData[index].h2so4
            }}
          </td>
          <td></td>
          <td>
            {{
              items.center.CenterlevelData[index] == undefined
              ? "0.00"
              : items.center.CenterlevelData[index].polymer
            }}
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>TOTAL</td>
          <td>{{ items.center.totalData.waterdata.total }}</td>
          <td>{{ items.center.totalData.powerdata.total }}</td>
          <td></td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.total4 }}</td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.total3 }}</td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.total2 }}</td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.total1 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>AVERAGE</td>
          <td>{{ items.center.totalData.waterdata.avg }}</td>
          <td>{{ items.center.totalData.powerdata.avg }}</td>
          <td></td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.avg4 }}</td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.avg3 }}</td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.avg2 }}</td>
          <td></td>
          <td>{{ items.center.totalData.leveldata.avg1 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <br />
    <h3>MBR Plant</h3>
    <br />

    <table id="testTable6" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.mbr != undefined">
      <tbody>
        <tr align="center">
          <td colspan="22">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of MBR Wastewater Treatment Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr align="center">
          <td rowspan="2">Plant</td>
          <td colspan="12">Quantity in Used</td>
          <td colspan="7">Cost in Used</td>
          <td colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr align="center">
          <td></td>
          <td></td>
          <td colspan="10">Quantity of Chemical</td>
          <td></td>
          <td colspan="6">Cost of Chemical</td>
        </tr>
        <tr align="center">
          <td>MBR</td>
          <td>Water</td>
          <td>Electricity</td>
          <td colspan="2">NaOH 50% (โซดาไฟ)</td>
          <td colspan="2">H<sub>2</sub>SO<sub>4</sub> 50% (กรดซัลฟูริค)</td>
          <td>Antifoam</td>
          <td colspan="3">Alkali (NaOH + NaOCl)</td>
          <td colspan="2">Acid (Citric)</td>
          <td>Cost of Electricity</td>
          <td>Cost of NaOH</td>
          <td>Cost of H<sub>2</sub>SO<sub>4</sub></td>
          <td>Cost of Alkali</td>
          <td>Cost o Acid</td>
          <td>Cost of Antifoam</td>
          <td>Total Cost of Chem.</td>
          <td>Cost of Chem./motorcycle</td>
          <td>ค่าบำบัดน้ำ/m3</td>
        </tr>
        <tr align="center">
          <td>หน่วย</td>
          <td>(m3)</td>
          <td>(Unit)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(L.)</td>
          <td>NaOCl (kg.)</td>
          <td>NaOH (kg.)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath./Unit</td>
          <td>Bath/m3</td>
        </tr>
        <tr v-for="(i, index) in items.mbr.powerData" :key="i" align="center">
          <td>{{ i == undefined ? "" : i.time }}</td>
          <td>
            {{
              items.mbr.waterData[index] == undefined
              ? "0.00"
              : items.mbr.waterData[index].water
            }}
          </td>
          <td>{{ i == undefined ? "0.00" : i.power }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>TOTAL</td>
          <td>{{ items.mbr.totalData.waterdata.total }}</td>
          <td>{{ items.mbr.totalData.powerdata.total }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>AVERAGE</td>
          <td>{{ items.mbr.totalData.waterdata.avg }}</td>
          <td>{{ items.mbr.totalData.powerdata.avg }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <br />
    <h3>Plastic painting WWTP Plant</h3>
    <br />
    <table id="testTable7" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.ef != undefined">
      <tbody>
        <tr align="center">
          <td colspan="18">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of E,F Wastewater Treatment Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr align="center">
          <td rowspan="2">Plant</td>
          <td colspan="9">Quantity in Used</td>
          <td colspan="6">Cost in Used</td>
          <td colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr align="center">
          <td></td>
          <td></td>
          <td colspan="7">Quantity of Chemical</td>
          <td></td>
          <td colspan="4">Cost of Chemical</td>
          <td></td>
        </tr>
        <tr align="center">
          <td>E,F</td>
          <td>Water</td>
          <td>Electricity</td>
          <td colspan="2">NaOH 50% (โซดาไฟ)</td>
          <td colspan="2">Al2(SO4)3 (สารส้ม)</td>
          <td colspan="2">Polymer</td>
          <td>Sludge</td>
          <td>Cost of Electricity</td>
          <td>Cost of NaOH</td>
          <td>Cost of Al2(SO4)3</td>
          <td>Cost of Polymer</td>
          <td>Total Cost of Chem.(฿)</td>
          <td>Cost of Sludge</td>
          <td>Cost of Chem./motorcycle</td>
          <td>ค่าบำบัดน้ำ ฿/m3</td>
        </tr>
        <tr align="center">
          <td>หน่วย</td>
          <td>(m3)</td>
          <td>(Unit)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(kg)</td>
          <td>(L.)</td>
          <td>(g)</td>
          <td>(big bags)</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath./Unit</td>
          <td>Bath/m3</td>
        </tr>
        <tr v-for="(i, index) in items.ef.powerData" :key="i" align="center">
          <td>{{ i == undefined ? "" : i.time }}</td>
          <td>
            {{
              items.ef.waterData[index] == undefined
              ? "0.00"
              : items.ef.waterData[index].water
            }}
          </td>
          <td>{{ i == undefined ? "0.00" : i.power }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>{{ items.ef.EFlevelData[index] == undefined ? '0.00': items.ef.EFlevelData[index].polymer }}</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>TOTAL</td>
          <td>{{ items.ef.totalData.waterdata.total }}</td>
          <td>{{ items.ef.totalData.powerdata.total }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>{{ items.ef.totalData.leveldata.total1 }}</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>AVERAGE</td>
          <td>{{ items.ef.totalData.waterdata.avg }}</td>
          <td>{{ items.ef.totalData.powerdata.avg }}</td>
          <td>-</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>{{ items.ef.totalData.leveldata.avg1 }}</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <br />
    <h3>Aluminium painting WWTP Plant</h3>
    <br />
    <table id="testTable8" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2" v-if="items.eg != undefined">
      <tbody>
        <tr align="center">
          <td colspan="23">
            {{
              data_text.type == 1
              ? "Weekly"
              : data_text.type == 2
                ? "Monthly"
                : "Yearly"
            }}
            Report of E/G Wastewater Treatment Plant in {{ data_text.week }}
            {{ data_text.month }} {{ data_text.year }}
          </td>
        </tr>
        <tr align="center">
          <td rowspan="2">Plant</td>
          <td colspan="12">Quantity in Used</td>
          <td colspan="8">Cost in Used</td>
          <td colspan="2" rowspan="2">Compare cost</td>
        </tr>
        <tr align="center">
          <td></td>
          <td></td>
          <td colspan="9">Quantity of Chemical</td>
          <td></td>
          <td></td>
          <td colspan="6">Cost of Chemical</td>
          <td></td>
        </tr>
        <tr align="center">
          <td>E/G</td>
          <td>Water</td>
          <td>Electricity</td>
          <td colspan="2">H<sub>2</sub>SO<sub>4</sub> 50% (ซัลฟูริค)</td>
          <td colspan="2">NaOH 50% (โซดาไฟ)</td>
          <td>Na2S2O5( เมต้า)</td>
          <td colspan="2">Al2(SO4)3 (สารส้ม)</td>
          <td colspan="2">Polymer(g)</td>
          <td>Sludge</td>
          <td>Cost of Electricity</td>
          <td>Cost of H<sub>2</sub>SO<sub>4</sub></td>
          <td>Cost of NaOH</td>
          <td>Cost of Na2S2O5</td>
          <td>Cost of Al2(SO4)3</td>
          <td>Cost of Polymer</td>
          <td>Total Cost of Chem.(฿)</td>
          <td>Cost of Sludge</td>
          <td>Cost of Chem./motorcycle</td>
          <td>ค่าบำบัดน้ำ /m3</td>
        </tr>
        <tr align="center">
          <td>หน่วย</td>
          <td>(m3)</td>
          <td>(Unit)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(kg.)</td>
          <td>(L.)</td>
          <td>(g.)</td>
          <td>(Big Bags)</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath.</td>
          <td>Bath./Unit</td>
          <td>Bath/m3</td>
        </tr>
        <tr v-for="(i, index) in items.eg.powerData" :key="i" align="center">
          <td>{{ i.time }}</td>
          <td>{{ items.eg.waterData[index].water }}</td>
          <td>{{ i.power }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            {{
              items.eg.EGlevelData[index] == undefined
              ? "0.00"
              : items.eg.EGlevelData[index].polymer
            }}
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>TOTAL</td>
          <td>{{ items.eg.totalData.waterdata.total }}</td>
          <td>{{ items.eg.totalData.powerdata.total }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ items.eg.totalData.leveldata.total1 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr align="center">
          <td>AVERAGE</td>
          <td>{{ items.eg.totalData.waterdata.avg }}</td>
          <td>{{ items.eg.totalData.powerdata.avg }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ items.eg.totalData.leveldata.avg1 }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <vs-row class="mt-4" vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-button color="success" class="btnSub" @click="
          tableToExcel(
            'testTable1',
            'testTable2',
            'testTable3',
            'testTable4',
            'testTable5',
            'testTable6',
            'testTable7',
            'testTable8',
            'W3C Example Table'
          )
          " type="filled">Download</vs-button>
        <!-- <vs-button
          color="success"
          class="btnSub"
          @click="tableToExcel2('testTable', 'W3C Example Table')"
          type="filled"
          >Download</vs-button
        > -->
      </vs-col> </vs-row><br /><br />
  </div>
</template>

<script>
import * as XLSX from "xlsx";
export default {
  props: {
    select_duration: String,
    select_plan: String,
    total_water_toilet: Number,
    total_water_treat: Number,
    total_electricity: Number,
    avg_water_toilet: Number,
    avg_water_treat: Number,
    avg_electricity: Number,
    items: Array,
    select_year: Number,
    data_text: Array,
  },
  data: () => ({
    table: "testTable",
    name: "W3C Example Table",
    data_sensor: [],
    items: [],
  }),
  methods: {
    tableToExcel(
      table1,
      table2,
      table3,
      table4,
      table5,
      table6,
      table7,
      table8,
      name1
    ) {
      var reName = "";
      if (this.data_text.type == 1) {
        reName = "Weekly ";
      } else if (this.data_text.type == 2) {
        reName = "Monthly ";
      } else if (this.data_text.type == 3) {
        reName = "Yearly ";
      }

      console.log(table1 + name1);
      let targetTableElm1 = document.getElementById(table1);
      let targetTableElm2 = document.getElementById(table2);
      let targetTableElm3 = document.getElementById(table3);
      let targetTableElm4 = document.getElementById(table4);
      let targetTableElm5 = document.getElementById(table5);
      let targetTableElm6 = document.getElementById(table6);
      let targetTableElm7 = document.getElementById(table7);
      let targetTableElm8 = document.getElementById(table8);

      const wb = { SheetNames: [], Sheets: {} };
      var ws1 = XLSX.utils.table_to_book(targetTableElm1).Sheets.Sheet1;

      wb.SheetNames.push("AS");
      wb.Sheets["AS"] = ws1;
      // wb.Sheets["AS"]['A1'] = {
      // 		"v": "Red",
      // 		"s": {
      // 			"fill": {
      // 				"bgColor": {
      // 					"rgb":"FFFFAA00"
      // 				}
      // 			}
      // 		},
      // 		"t": "s"
      // 	}

      var ws2 = XLSX.utils.table_to_book(targetTableElm2).Sheets.Sheet1;
      wb.SheetNames.push("RO");
      wb.Sheets["RO"] = ws2;
      var ws3 = XLSX.utils.table_to_book(targetTableElm3).Sheets.Sheet1;
      wb.SheetNames.push("Recycle");
      wb.Sheets["Recycle"] = ws3;
      var ws4 = XLSX.utils.table_to_book(targetTableElm4).Sheets.Sheet1;
      wb.SheetNames.push("DAF");
      wb.Sheets["DAF"] = ws4;
      var ws5 = XLSX.utils.table_to_book(targetTableElm5).Sheets.Sheet1;
      wb.SheetNames.push("Center");
      wb.Sheets["Center"] = ws5;
      var ws6 = XLSX.utils.table_to_book(targetTableElm6).Sheets.Sheet1;
      wb.SheetNames.push("MBR");
      wb.Sheets["MBR"] = ws6;
      var ws7 = XLSX.utils.table_to_book(targetTableElm7).Sheets.Sheet1;
      wb.SheetNames.push("E,F");
      wb.Sheets["E,F"] = ws7;
      var ws8 = XLSX.utils.table_to_book(targetTableElm8).Sheets.Sheet1;
      wb.SheetNames.push("E-G");
      wb.Sheets["E-G"] = ws8;

      const blob = new Blob(
        [this.s2ab(XLSX.write(wb, { bookType: "xlsx", type: "binary" }))],
        {
          type: "application/octet-stream",
        }
      );
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        reName +
        "Report in " +
        this.data_text.week +
        " " +
        this.data_text.month +
        " " +
        this.data_text.year +
        ".xlsx";

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    },
    tableToExcel2(table1, name1) {
      console.log(table1 + name1);
      var uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet><x:ExcelWorksheet><x:Name>{worksheet_2}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        template2 =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet_2}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table_2}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      table1 = document.getElementById(table1);
      var ctx = { worksheet: "111" || "Worksheet", table: table1.innerHTML };
      var ctx2 = {
        worksheet_2: "1111s" || "Worksheet",
        table_2: table1.innerHTML,
      };
      window.location.href =
        uri + [base64(format(template, template, ctx, ctx2))];
      return window.location.href;
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
  },
  mounted() {
    console.log(this.select_duration);
  },
};
</script>

<style scoped>
table,
td,
th {
  border: 1px solid #111111;
  border-collapse: collapse;
  font-size: 15px;
}

/* td, th {
	padding: 3px;
	width: 30px;
	height: 25px;
} */
th {
  background: #f0e6cc;
}

.even {
  background: #fbf8f0;
}

.odd {
  background: #fefcf9;
}

.btnSub {
  width: 100px;
  border-radius: 20px;
}

.cardRadi {
  border-radius: 20px;
}
</style>